import React from 'react';
import { Button } from '@mui/material';

function OtherFilter({ onClick }) {
    return (
        <Button variant="contained" onClick={onClick} sx={{ fontFamily: 'SUSE, sans-serif', backgroundColor: '#2596BE', }}>
            Afficher les K-Dramas de cette année
        </Button>
    );
}

export default OtherFilter;
